import { useCallback } from 'react';
import * as turf from '@turf/turf';

const useGeoJSONCenter = () => {
  return useCallback(geoJSON => {
    try {
      if (!geoJSON) return null;

      let target = geoJSON;
      if (
        geoJSON.type === 'FeatureCollection' &&
        Array.isArray(geoJSON.features) &&
        geoJSON.features.length > 0
      ) {
        target = geoJSON.features[0]; // Navigate to the center of the 1st polygon/feature
      }

      const center = turf.center(target);
      if (center?.geometry?.coordinates) {
        return {
          lat: center.geometry.coordinates[1],
          lng: center.geometry.coordinates[0]
        };
      }
      return null;
    } catch (error) {
      console.error('Error calculating GeoJSON center:', error);
      return null;
    }
  }, []);
};

export default useGeoJSONCenter;
